export default __webpack_public_path__ + "static/media/engage-phone.86bbbf0c.svg";